import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

// components
import { Button } from "@quorumus/plum"
import { Icon } from "@/components"

// action creators
import { removeResourceTableRow } from "app/static/frontend/sheets/sheet-action-creators"

// selectors
import { basicActionConnection } from "app/static/frontend/sheets/components/cells/action-buttons/selectors"

export const ArchiveAction = (props) => (
    <Button
        leftSection={<Icon icon={props.icon} iconFamily="fas" />}
        onClick={async () => {
            const willArchive = await swal({
                buttons: ["Cancel", "Archive"],
                title: props.dataType
                    ? `Are you sure you want to archive this ${DjangIO.app.models.QuorumDataType.by_value(props.dataType).singular}?`
                    : `Are you sure you want to archive it?`,
                text: "It will no longer be accessible.",
                icon: "warning",
            })

            if (willArchive) {
                const result = await props.removeResourceTableRow(props.tableId, props.id)

                if (props.callbackFn) {
                    props.callbackFn(result)
                }
            }
        }}
        variant={props.variant || "tertiary"}
    >
        {props.text}
    </Button>
)

ArchiveAction.propTypes = {
    callbackFn: PropTypes.func,
    dataType: PropTypes.number,
    fields: PropTypes.object.isRequired,
    icon: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    removeResourceTableRow: PropTypes.func.isRequired,
    tableId: PropTypes.string,
    text: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    variant: PropTypes.string,
}

export default connect((state, props) => basicActionConnection(state, props), { removeResourceTableRow })(ArchiveAction)
